import React from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import App from './App';
import './index.css'; // 注意: このファイルは作成していませんが、スタイルが必要な場合は別途作成してください
import './styles/designSystem.css'; // デザインシステムCSSをインポート
import './styles/layout.css'; // レイアウトCSSをインポート
import './styles/components.css'; // コンポーネントCSSをインポート

// MSALインスタンスの初期化
const msalInstance = new PublicClientApplication(msalConfig);

// リダイレクト後の認証結果を処理
msalInstance.handleRedirectPromise()
  .then(response => {
    // リダイレクト後の認証成功時の処理
    if (response) {
      console.log('ログイン成功:', response);
    }
  })
  .catch(error => {
    console.error('認証エラー:', error);
  });

// React 18のcreateRootを使用してアプリケーションをレンダリング
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // MsalProviderでアプリケーション全体をラップして認証コンテキストを提供
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

// 注意: このサンプルアプリを実行するには、以下の手順が必要です：
// 1. Azure AD B2Cテナントを作成し、アプリケーションを登録
// 2. authConfig.jsの設定を実際の値に置き換え
// 3. 必要なパッケージをインストール: npm install @azure/msal-react @azure/msal-browser react react-dom
// 4. アプリケーションを起動: npm start
